"use strict";

function compareModal() {
  let open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (open) {
    let button = event.target.closest('.add-to-compare-btn');
    if(button.classList.contains('disabled')) {
      return;
    }
    body.classList.add("open");
    modalCompare.classList.add("active");
    document.querySelector(".backdrop").addEventListener("click", ev => {
      ev.preventDefault();
      ev.stopPropagation();
      modalCompare.classList.remove("active");
    });
  } else {
    body.classList.remove("open");
    modalCompare.classList.remove("active");
    document.querySelector(".backdrop").removeEventListener("click", ev => {
      ev.preventDefault();
      ev.stopPropagation();
      modalCompare.classList.remove("active");
    });
  }
}

function linkToCompare(handle) {
  const clickedElement = event.target.closest('.stop-link');
  let handlesCount = null;

  if (localStorage && !clickedElement.classList.contains('compare-product__remove')) {
    handlesCount = localStorage.getItem('c-panel-state');
    if (handlesCount === '3') {
      //alert('Maximum 3 products');
      checkComparisionNumber();
      return;
    }
  } 

  let add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let currentPath = location.pathname;
  let newPath;

  if (add && currentPath.includes(handle)) {
    console.log("This product is already added");
    return;
  }

  if (add) {
    newPath = currentPath + "-vs-" + handle;
  } else {
    newPath = currentPath.replace("-vs-" + handle, "").replace(handle + "-vs-", "").replace(handle, "");
  }
  document.location.href = newPath;
}

// modal reload compare
function reloadCompare() {
  if (!localStorage) return;
  var raw = localStorage.getItem("c-panel-handle");
  if (!raw) {
    window.location.href = "/tools/compare";
    return;
  }
  var handles = raw
    .split(",")
    .map(function (h) {
      return h.trim();
    })
    .filter(Boolean);
  if (!handles.length) {
    window.location.href = "/tools/compare";
    return;
  }
  var comparePrefix = "/tools/compare/";
  window.location.href = comparePrefix + handles.join("-vs-");
}


function getCompareSectionScrollTop(heading) {
  return heading.offsetTop - (window.innerHeight - heading.offsetHeight) / 2;
}

function linkToSection(event) {
  let id;
  if (event.type == "click") {
    const navEl = event.target.closest("[nav-item]");
    id = navEl ? navEl.getAttribute("nav-item") : null;
  } else if (event.type == "change") {
    id = event.target.value;
  }
  const heading = findHeadingById(id);
  if (heading) {
    window.scrollTo({
      top: Math.max(getCompareSectionScrollTop(heading), 0),
      behavior: "smooth"
    });
  }
}

function updateCompareNavActive() {
  const navItems = document.querySelectorAll(".compare-nav__list [nav-item]");
  if (!navItems.length) return;

  const scrollY = window.pageYOffset || document.documentElement.scrollTop;
  let activeId = navItems[0].getAttribute("nav-item");

  navItems.forEach(function (li) {
    const id = li.getAttribute("nav-item");
    const heading = findHeadingById(id);
    if (!heading) return;
    if (scrollY >= getCompareSectionScrollTop(heading) - 1) {
      activeId = id;
    }
  });

  navItems.forEach(function (li) {
    li.classList.toggle("is-active", li.getAttribute("nav-item") === activeId);
  });
}

var compareNavActiveRaf = null;
function scheduleCompareNavActive() {
  if (compareNavActiveRaf) return;
  compareNavActiveRaf = requestAnimationFrame(function () {
    compareNavActiveRaf = null;
    updateCompareNavActive();
  });
}

let compare_nav_list = document.querySelectorAll("[nav-item]");
let body = document.querySelector("body");
let modalCompare = document.querySelector(".compare-modal");
compare_nav_list.forEach(item => {
  item.addEventListener('click', ev => linkToSection(ev));
});

window.addEventListener("scroll", scheduleCompareNavActive, { passive: true });
window.addEventListener("resize", scheduleCompareNavActive);
updateCompareNavActive();


let screenSliders = Array.from(document.querySelectorAll(".screenshots-slider"));
let viewScreens = Array.from(document.querySelectorAll(".media-content__img"));
viewScreens.forEach(view => {
  view.addEventListener("click", () => {
    let dataSlider = view.getAttribute("data-slider");
    body.classList.add("open");
    screenSliders.map(x => {
      if (x.getAttribute("data-slider") == dataSlider) {
        x.classList.add("active");
        let slider_x = new Glide(x).mount();
        slider_x.on('run.after', () => {
          reloadYoutube();
        });
        document.querySelector(".backdrop").addEventListener("click", ev => {
          ev.preventDefault();
          ev.stopPropagation();
          x.classList.remove("active");
          reloadYoutube();
        });
      }
    });
  });
});


function reloadYoutube() {
  document.querySelectorAll('iframe[src*="youtube"]').forEach(iframe => {
    const src = iframe.src;
    iframe.src = ''; 
    iframe.src = src; 
  });
}


let overviewSection = document.querySelector(".section-compare--overview");
let navigationSection = document.querySelector(".compare-nav");
if (overviewSection && navigationSection) {
  let overviewEmitation = document.createElement("div");
  let navigationEmitation = document.createElement("div");
  overviewEmitation.classList.add("section-emit");
  navigationEmitation.classList.add("section-emit");
  overviewSection.after(overviewEmitation);
  navigationSection.after(navigationEmitation);

  const stickyHightOffset = 0; // tune this value if needed
  let overviewHeight = overviewSection.offsetHeight;
  let navigationHeight = navigationSection.offsetHeight;
  let headerHeight = 0;
  let stickyHight = overviewSection.offsetTop - headerHeight - stickyHightOffset;

  function getHeaderHeight() {
    let headerEl = document.querySelector(".section-header");
    return headerEl ? headerEl.offsetHeight : 0;
  }

  function updateCompareStickyBounds() {
    overviewHeight = overviewSection.offsetHeight;
    navigationHeight = navigationSection.offsetHeight;
    headerHeight = getHeaderHeight();
    stickyHight = overviewSection.offsetTop - headerHeight - stickyHightOffset;
  }

  function syncCompareStickyTops() {
    let headerH = getHeaderHeight();
    let overviewH = overviewSection.offsetHeight;
    document.documentElement.style.setProperty("--compare-sticky-overview-top", headerH + "px");
    document.documentElement.style.setProperty("--compare-sticky-nav-top", headerH + overviewH + "px");
  }

  function clearCompareStickyTops() {
    document.documentElement.style.removeProperty("--compare-sticky-overview-top");
    document.documentElement.style.removeProperty("--compare-sticky-nav-top");
  }

  window.addEventListener("resize", updateCompareStickyBounds);
  updateCompareStickyBounds();

  window.addEventListener("scroll", function () {
    const shouldBeSticky = window.scrollY > stickyHight;
    if (shouldBeSticky) {
      overviewEmitation.style.height = overviewHeight + "px";
      navigationEmitation.style.height = navigationHeight + "px";
      overviewSection.classList.add("sticky");
      navigationSection.classList.add("sticky");
      syncCompareStickyTops();
    } else {
      overviewEmitation.style.height = "0px";
      navigationEmitation.style.height = "0px";
      overviewSection.classList.remove("sticky");
      navigationSection.classList.remove("sticky");
      clearCompareStickyTops();
    }
    scheduleCompareNavActive();
  });
}

document.querySelector(".backdrop").addEventListener("click", ev => {
  ev.preventDefault();
  ev.stopPropagation();
  body.classList.remove("open");
});


class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce(event => {
      this.onChange(event);
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&type=product`).then(response => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    }).then(text => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results').outerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    }).catch(error => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    var _this = this;
    let t;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(t);
      t = setTimeout(() => fn.apply(_this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch); 